import {
  AlertModal,
  ArrowIcon,
  Box,
  Button,
  DestructiveIcon,
  ErrorModal,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
  TextLink,
} from '@modusign/design-system';

import { MaxActiveLinksError, PARTICIPANTS_COUNT_ERROR } from '../../convertToContractLinkErrors';

interface CreateLinkErrorModalProps {
  error: Error | null;
  hasLink: boolean;
  onConfirm: () => void;
}

const defaultProps = {
  hasLink: true,
};

function CreateLinkErrorModal({ error, hasLink, onConfirm }: CreateLinkErrorModalProps) {
  if (!error) {
    return null;
  }

  if (error.message === PARTICIPANTS_COUNT_ERROR) {
    return (
      <AlertModal isOpen maxWidth="xs" title="링크서명 안내" variant="warning" onClose={onConfirm}>
        링크서명에 사용할 수 없는 템플릿입니다.
        <br />
        서명자가 1명만 설정되어 있어야 합니다.
        <TextLink
          display="block"
          href="https://support.modusign.co.kr/hc/ko/articles/4508382307737"
          sx={{
            mt: 4,
          }}
          target="_blank"
        >
          자세히 알아보기 <ArrowIcon direction="right" ml="2px" />
        </TextLink>
      </AlertModal>
    );
  }

  if (error instanceof MaxActiveLinksError) {
    return (
      <Modal isOpen maxWidth="xxs" onClose={onConfirm}>
        <ModalTitle icon={<DestructiveIcon color="iconPrimaryBase" />}>링크서명 안내</ModalTitle>
        <ModalContent>
          <Text as="p" mb={6} textAlign="center" whiteSpace="pre-wrap">
            더이상 링크서명을 시작할 수 없습니다.
            <br />
            링크 {error.currentActiveLinks - error.maxActiveLinks + 1}개를 비활성화해 주세요.
          </Text>
          <Box
            bg="boxBackgroundNeutralBase"
            border="1px solid"
            borderColor="boxBorderNeutralBase"
            px={6}
            py={7}
            textAlign="left"
          >
            <Text>
              동시에 서명을 진행할 수 있는 링크 개수는 최대 {error.maxActiveLinks}개입니다.
            </Text>
          </Box>
          {hasLink && (
            <Box mt={6} textAlign="center">
              <TextLink to="/links">
                링크 비활성화하기 <ArrowIcon direction="right" />
              </TextLink>
            </Box>
          )}
        </ModalContent>
        <ModalFooter>
          <Button onClick={onConfirm}>확인</Button>
        </ModalFooter>
      </Modal>
    );
  }

  return <ErrorModal error={error} isOpen title="링크 만들기 오류" onClose={onConfirm} />;
}

CreateLinkErrorModal.defaultProps = defaultProps;

export default CreateLinkErrorModal;
